// @ts-nocheck
// Store Custom Code
import getColor from "@insite/mobius/utilities/getColor";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import { focusStyles } from "@toolkit/Themes/common/mixins";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

/**
 * Shared styling for the compact, transparent icon action buttons used in the
 * My Lists Details header (favorite, tags, info). Keeps colour, hover and focus
 * treatment consistent with the project convention (primary base, secondary on
 * hover) and pulls from the theme rather than hard-coded values.
 */
export const iconActionButtonStyles = () => css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: 0;
    padding: ${pxToRem(4)};
    min-height: ${pxToRem(34)};
    min-width: ${pxToRem(34)};
    cursor: pointer;
    color: ${getColor("primary")};
    transition: ${transitionHoverStyles("color")};
    ${focusStyles()}

    &:hover,
    &:active {
        color: ${getColor("secondary")};
    }

    &:disabled {
        color: ${getColor("text.disabled")};
        cursor: default;
    }
`;
